import { useSearchAuctionResume } from './events/search/useSearchAuctionResume'
import { useSearchBidDeleted } from './events/search/useSearchBidDeleted'
import { useSearchBidOnAgent } from './events/search/useSearchBidOnAgent'
import { useSearchCarFinish } from './events/search/useSearchCarFinish'
import { useSearchCarInPrepare } from './events/search/useSearchCarInPrepare'
import { useSearchCarNotSold } from './events/search/useSearchCarNotSold'
import { useSearchCarReserved } from './events/search/useSearchCarReserved'
import { useSearchCarSold } from './events/search/useSearchCarSold'
import { useSearchItemReserveRelese } from './events/search/useSearchItemReserveRelese'
import { useSearchItemWithdrawOrDelete } from './events/search/useSearchItemWithdrawOrDelete'
import { useSearchUserBid } from './events/search/useSearchUserBid'

export const SEARCH_SOCKET_CALLBACK = 'search-list-update'

export function useSearchCarsSocket() {
  const { userBid } = useSearchUserBid()
  const { auctionResume } = useSearchAuctionResume()
  const { itemWithdrawOrDelete } = useSearchItemWithdrawOrDelete()
  const { bidDeleted } = useSearchBidDeleted()
  const { carInPrepare } = useSearchCarInPrepare()
  const { carNotSold } = useSearchCarNotSold()
  const { carSold } = useSearchCarSold()
  const { carReserved } = useSearchCarReserved()
  const { itemReserveRelease } = useSearchItemReserveRelese()
  const { carFinished } = useSearchCarFinish()
  const { bidOnAgent } = useSearchBidOnAgent()

  const init = () => {
    userBid()
    auctionResume()
    itemWithdrawOrDelete()
    bidDeleted()
    carInPrepare()
    carNotSold()
    carSold()
    carReserved()
    itemReserveRelease()
    carFinished()
    bidOnAgent()
  }

  return { init }
}
